import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from '../../services/api.service';
import { ProductDTO } from '../../models/product-dto';
import { SystemDTO } from '../../models/system-dto';
import { RouterLink } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MediaComponent } from '../media/media.component';
import { ReplaceWhitespaceWithUnderscorePipe } from '../../pipes/replace-whitespace-with-underscore.pipe';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-search',
  imports: [FormsModule, TranslateModule, ReplaceWhitespaceWithUnderscorePipe, RouterLink, InlineSVGModule, MediaComponent],
  templateUrl: './modal-search.component.html',
  styleUrl: './modal-search.component.scss'
})
export class ModalSearchComponent {
  protected searchTerm: string = '';

  private readonly apiService = inject(ApiService);

  protected readonly products$ = this.apiService.getProductItems$();
  protected readonly systems$ = this.apiService.getSystemItems$();

  private searchableItems: (ProductDTO | SystemDTO)[] = [];
  protected visibleItems: (ProductDTO | SystemDTO)[] = [];

  @Output() close = new EventEmitter<void>;

  ngOnInit() {
    this.products$.subscribe(produdcts => {
      this.searchableItems.push(...produdcts.data);
    });
    this.systems$.subscribe(produdcts => {
      this.searchableItems.push(...produdcts.data);
    });
  }

  protected castToProduct(value: ProductDTO | SystemDTO) {
    if ((value as ProductDTO).catalogue_number) { return true; }
    return false;
  }

  protected openManual(event: any, product: any): void {
    if (!product.manual) {
      return;
    }
    event.stopPropagation();
    window.open(`${environment.strapiBaseUrl}${product.manual.url}`, '_blank');
  }

  protected search() {
    if (!this.searchTerm) { this.visibleItems.length = 0; return; }
    this.visibleItems = this.searchableItems.filter(item => {
      let result: boolean = false;
      if ((item as ProductDTO).catalogue_number) {
        result = (item as ProductDTO).catalogue_number.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase())
      }
      result = (item.title.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()) ||
        item.caption?.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase())) || false;
      return result;
    });
  }
}
